import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface SurveyEmoji4Props {
  color?: string;
  style?: React.CSSProperties;
}

export const SurveyEmoji4Icon = ({ color = RoutalPalette.white, style = {}, ...props }: SurveyEmoji4Props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 58 59" style={{ width: `58px`, height: `59px`, ...style }}>
      <ellipse cx="28.9992" cy="29.4038" rx="14.9914" ry="15" fill="#FEC654" />
      <path
        d="M27.5 24.9037C28.3285 24.9037 29 23.9683 29 22.8143C29 21.6605 28.3285 20.7251 27.5 20.7251C26.6715 20.7251 26 21.6605 26 22.8143C26 23.9683 26.6715 24.9037 27.5 24.9037ZM35 20.7251C34.1715 20.7251 33.5 21.6605 33.5 22.8143C33.5 23.9683 34.1715 24.9037 35 24.9037C35.8285 24.9037 36.5 23.9683 36.5 22.8143C36.5 21.6605 35.8285 20.7251 35 20.7251Z"
        fill="#4D4D4D"
      />
      <path
        d="M31.2268 30.8589C31.2336 30.8589 31.2403 30.8589 31.2481 30.8589C32.5971 30.8589 33.8113 30.3856 34.4979 29.5914C34.8567 29.1763 34.8121 28.5498 34.397 28.191C34.2089 28.028 33.9781 27.9485 33.7473 27.9485C33.4689 27.9485 33.1925 28.0649 32.9966 28.2918C32.7455 28.5818 32.1083 28.8727 31.2481 28.8727C31.2433 28.8727 31.2384 28.8727 31.2345 28.8727C30.385 28.8698 29.743 28.5828 29.4831 28.3006C29.1107 27.8952 28.4832 27.87 28.0798 28.2414C27.6763 28.6128 27.6492 29.2403 28.0206 29.6447C28.715 30.4002 29.9137 30.854 31.2268 30.8589Z"
        fill="#4D4D4D"
      />
    </SvgIcon>
  );
};
